import React from "react";
import "./styles.css";

export const Skeleton = ({ className }: { className?: string }) => {
  return <div className={`skeleton ${className}`} />;
};
